module.exports = __webpack_public_path__ + "img/ppbg.7f07c0a5.jpg";